module.exports = __webpack_public_path__ + "media/madeca-small.ea202adc.mp4";